import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Label } from '@/components/ui/label';

interface MediaFiltersProps {
  filters: {
    status?: string;
    source_type?: string;
  };
  onChange: (filters: any) => void;
  showSourceFilter?: boolean;
}

export const MediaFilters: React.FC<MediaFiltersProps> = ({ filters, onChange, showSourceFilter = false }) => {
  return (
    <div className="flex gap-4 items-end">
      <div className="flex-1">
        <Label htmlFor="status-filter">Status</Label>
        <Select
          value={filters.status || 'all'}
          onValueChange={(value) => onChange({ ...filters, status: value === 'all' ? undefined : value })}
        >
          <SelectTrigger id="status-filter">
            <SelectValue placeholder="All statuses" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All statuses</SelectItem>
            <SelectItem value="completed">Completed</SelectItem>
            <SelectItem value="processing">Processing</SelectItem>
            <SelectItem value="failed">Failed</SelectItem>
            <SelectItem value="queued">Queued</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {showSourceFilter && (
        <div className="flex-1">
          <Label htmlFor="source-filter">Source</Label>
          <Select
            value={filters.source_type || 'all'}
            onValueChange={(value) => onChange({ ...filters, source_type: value === 'all' ? undefined : value })}
          >
            <SelectTrigger id="source-filter">
              <SelectValue placeholder="All sources" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All sources</SelectItem>
              <SelectItem value="ai_generated">AI Generated</SelectItem>
              <SelectItem value="uploaded">Uploaded</SelectItem>
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
};
